// 카테고리 폼에서 필수 정보 유효성 검사 메세지
export const INVALID_REQUIRED_MESSAGE = '필수 정보 입력해주세요';

// 카테고리 명 필수 유효성 검사 메세지
export const INVALID_REQUIRED_CATEGORY_NAME_MESSAGE = '카테고리명을 입력해주세요';

// 카테고리 명 정규 표현식 유효성 검사 메세지
export const INVALID_CATEGORY_NAME_MESSAGE = '한글, 영어, 숫자, 특수문자만 입력 가능합니다';

// 카테고리 서브 텍스트 정규 표현식 유효성 검사 메세지
export const INVALID_CATEGORY_SUB_TEXT_MESSAGE = '한글, 영어, 숫자만 입력 가능합니다';
